import { axiosInstance } from '@/shared/core';

import {
  Book,
  BookUploadImage,
  GetBookAuthors,
  GetBookCategories,
  GetBookPublishers,
  GetBooks,
  SaveBook,
} from '../model/types';

/**
 * Получение списка книг
 *
 * @returns Список книг GetBooks
 */
export const getAllBooks = async (
  params?: {
    limit?: number;
    offset?: number;
    published?: boolean;
    searchQuery?: string;
  },
  signal?: AbortSignal,
): Promise<GetBooks> => {
  const response = await axiosInstance.get<GetBooks>('/book/getAll', {
    params: params,
    signal,
  });

  return response.data;
};

/**
 * Получение книги
 *
 * @returns Список книг Book
 */
export const getBookById = async (bookId: string): Promise<Book> => {
  const response = await axiosInstance.get<Book>(`/book/get?bookId=${bookId}`);

  return response.data;
};

/**
 * Создание книги
 *
 * @returns Созданная книга Book
 */
export const createBook = async (data: SaveBook): Promise<Book> => {
  return await axiosInstance.post('/book/create', data);
};

/**
 * Редактирование книги
 *
 * @returns Отредактированная книга Book
 */
export const updateBook = async (
  bookId: string,
  data: SaveBook,
): Promise<Book> => {
  return await axiosInstance.post(`/book/update?bookId=${bookId}`, data);
};

/**
 * Удаление книги
 *
 * @returns Отредактированная книга Book
 */
export const deleteBook = async (id: number) => {
  return await axiosInstance.post(`/book/delete`, { id });
};

/**
 * Загрузка картинки
 *
 * @returns Сохраненная картинка BookUploadImage
 */
export const addBookImage = async (
  data: FormData,
): Promise<BookUploadImage> => {
  return (await axiosInstance.post('/book/uploadImage', data)).data;
};

/**
 * Получение категорий книг
 *
 * @returns Список категорий книг GetBookCategories
 */
export const getBookCategories = async (): Promise<GetBookCategories> => {
  const response =
    await axiosInstance.get<GetBookCategories>('/category/getAll');

  return response.data;
};

/**
 * Получение авторов книг
 *
 * @returns Список категорий книг GetBookAuthors
 */
export const getBookAuthors = async (): Promise<GetBookAuthors> => {
  const response = await axiosInstance.get<GetBookAuthors>('/author/getAll');

  return response.data;
};

/**
 * Получение издательств книг
 *
 * @returns Список издательств книги GetBookPublishers
 */
export const getBookPublishers = async (): Promise<GetBookPublishers> => {
  const response =
    await axiosInstance.get<GetBookPublishers>('/publisher/getAll');

  return response.data;
};
